/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { useContext } from 'react';
import { ThemeProvider } from '@emotion/react';
import { TextDirectionContext } from '@instructure/ui-i18n';
import { DeterministicIdContextProvider } from '@instructure/ui-react-utils';
import { getTheme } from "../getTheme.js";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * ---
 * category: components
 * ---
 * @module InstUISettingsProvider
 */
function InstUISettingsProvider({
  children,
  theme = {},
  dir,
  instanceCounterMap
}) {
  const finalDir = dir || useContext(TextDirectionContext);
  if (process.env.NODE_ENV !== 'production' && finalDir === 'auto') {}
  let providers = _jsx(DeterministicIdContextProvider, {
    instanceCounterMap: instanceCounterMap,
    children: _jsx(ThemeProvider, {
      theme: getTheme(theme),
      children: _jsx(TextDirectionContext.Provider, {
        value: finalDir,
        children: children
      })
    })
  });
  if (dir) {
    providers = _jsx("span", {
      dir: finalDir,
      children: providers
    });
  }
  return providers;
}
export default InstUISettingsProvider;
export { InstUISettingsProvider };